module.exports = "/assets/3b124e0fe8149bc4fa3c021710117b63.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/XY.png
// module id = 2013
// module chunks = 0